// extracted by mini-css-extract-plugin
module.exports = {"UiBadge":"badge_UiBadge__l3jIc","UiBadge__label":"badge_UiBadge__label__udkqF"};